import { render, staticRenderFns } from "./CashierPage.vue?vue&type=template&id=094e7582&scoped=true"
import script from "./CashierPage.vue?vue&type=script&lang=js"
export * from "./CashierPage.vue?vue&type=script&lang=js"
import style0 from "./CashierPage.vue?vue&type=style&index=0&id=094e7582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e7582",
  null
  
)

export default component.exports